const $functions = require('./functions');
const Fraction = require('./Fraction');
const { wordsToNumbers } = require('words-to-numbers');
const writtenNumber = require('written-number');
const convertRoman = require("roman-to-arabic-numerals");
require('usefull-functions');

var ppcm = $functions.ppcm;


const
escapeString = {
    start: '/%',
    end: '%/'
},
month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
day_names = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
month_31 = ['January', 'March', 'May', 'July', 'August', 'October', 'December'],
month_30 = ['April', 'June', 'September', 'November'],
actual_date=new Date(),
grades = [
    { class: 'pre-k', limitNumber: 5 },
    { class: 'kindergaten', limitNumber: 10 },
    { class: 'first-grade', limitNumber: 20 },
    { class: 'second-grade', limitNumber: 50 },
    { class: 'third-grade', limitNumber: 100 },
    { class: 'fourth-grade', limitNumber: 500 },
    { class: 'fifth-grade', limitNumber: 1500 },
    { class: 'sixth-grade', limitNumber: 10000 },
    { class: 'any', limitNumber: 10000 }
],
variables = {
    int(){
        return rn(0, Infinity, 0);
    },
    float(precision = 2){
        return rn(0, Infinity, precision);
    },
    number(level){
        return rn(0, grades.filter(el => el.class == level)[0].limitNumber);
    },
    name: ['Aaron', 'Paul', 'David', 'Boris'],
    time: ['at morning', 'on afternoon', 'at night', 'at evening'],
    fruit: ['oranges', 'fruits', 'apples', 'lemons', 'avocados', 'cherries'],
    unit: ['oranges', 'fruits', 'ices'],
    places: ['school', 'house', 'office'],
    container: ['bag', 'box', 'bottle', 'bucket'],
    money: ["$"],
    girl: ["Anita","Dixie","Luisa","Kaiya", "Maya", "Aiden", "Ruby", "Kennedy", "Ivy", "Ariana", "Aaliyah", "Cora", "Madelyn", "Alice", "Kinsley", "Hailey", "Gabriella", "Allison", "Gianna", "Serenity", "Samantha", "Sarah", "Autumn", "Quinn", "Eva", "Piper", "Sophie", "Sadie", "Delilah", "Josephine", "Nevaeh", "Adeline", "Arya", "Emery", "Lydia", "Clara", "Vivian", "Madeline", "Peyton", "Julia", "Rylee", "Brielle", "Reagan", "Natalia", "Jade", "Athena", "Maria", "Leilani", "Everleigh", "Liliana", "Melanie", "Mackenzie", "Hadley", "Raelynn", "Kaylee",'Delilah',"Olivia", "Emma", "Ava", "Sophia", "Isabella", "Charlotte", "Amelia", "Mia"],
    boy: ["Arthur", "Leon", "Felix", "Remington", "Jake", "Killian", "Clayton", "Sean", "Adriel", "Riley", "Archer", "Legend", "Erick", "Enzo", "Corbin", "Francisco", "Emilio", "Gunner", "Simon", "Andre", "Walter", "Damien", "Chance", "Phoenix", "Colt", "Tanner", "Stephen", "Kameron", "Manuel", "Amari"],
    young: ['Paul','Bob','Lucy','Andrea','Nelson','Anthony','Aline','John','Ali','Hamid','Anton','Bill','Agatha','Melvin','Oliver','Kobe','Lucy','Aton','Lily','Joshua','Aliya','Linsey','Susan','Bill','Jade','Ornella','Sandra','Madi','Leony','Jules','Sally','Adams','Eve','Yvan','Peter','Paul','Marcus','Mary','Jan','Charles'],
    mister: ["Smith", "Noah", "Liam", "Taylor", "Reed", "Garrett", "Michael", "William", "Ricard", "Joseph", "Thomas", "Christopher", "Daniel", "Paul", "Mark", "Donald", "George", "Kenneth", "Steven", "Edward", "Brian", "Ronald", "Anthony", "Kevin", "Jason", "Matthew", "Gary", "Timothy", "Jose", "Larry", "Jeffrey", "Frank", "Scott", "Eric", "Stephen", "Raymond", "Gregory", "Joshua", "Jerry", "Dennis", "Walter", "Patrick", "Peter", "Harold", "Douglas", "Henry", "Carl", "Arthur", "Ryan", "Roger", "Joe", "Juan", "Jack", "Albert", "Jonathan", "Justin", "Terry"],
    mrs: ["Ela", "Anna", "Ava", "Isabella", "Hailey", "Sarah", "Clara", "Esther", "Lilly", "Gracie"],
    month: month_names,
    day: day_names,
    month_30: month_30,
    month_31: month_31,
    game: ['Sudoku', 'Brain Boxes', 'Magic Word', 'Picture Bingo', 'Color Recall', 'Song Recall', 'Guess Who'],
    sport: ['handball', 'soccer ball', 'volleyball', 'basketball', 'baseball', 'hockey', 'tennis ball',"Athletic", "Tenis", "Natation", "Jumping"],
    species: ['Goslings','Foals','Sheep','Calves'],
    person: ['Miss. Amare', 'Mr. Kwame', 'Mr. Feechi', 'Mrs. Ekon', 'Mr. Zane', 'Mrs. Isabis', 'Mr. Jafari', 'Miss. Daliah', 'Mrs. Haji', 'Miss. Sabra', 'Mr. Kalifa', 'Mr. Imani', 'Miss. Asha', 'Mrs. Ode', 'Mr. Lulu', 'Mrs. Uma', 'Miss. Maha', 'Mr. Bahati', 'Miss. Ada', 'Miss. Adana', 'Miss. Alika', 'Miss. Ama', 'Mrs. Azibo', 'Miss. Binah', 'Mr. Bobo', 'Mrs. Chike', 'Miss. Dalia', 'Mr. Dakarai', 'Mr. Davu', 'Mr. Ekon', 'Mrs. Haji', 'Mr. Hasani', 'Mrs. Idi', 'Miss. Imani', 'Mr. Jabarl', 'Miss. Jamila', 'Mr. Kaikura', 'Mr. Kasim', 'Mr. Hamid'],
    state: ["Florida","Alabama","Colorado","Georgia","Kentucky","New Jersey", "Indiana", "Guam", "Delaware", "California","Florida", "Alabama", "Colorado", "Georgia", "Kentucky", "New Jersey", "Indiana", "Guam", "Delaware", "California", "South Yorkshire", "Oxfordshire", "Derbyshire", "Wiltshire", "Cheshire", "Bristol", "Texas"],
    actor: ['Fabulous Jones', 'Little Teeth', 'Lornewolf', 'Baby Moon', 'Alita Gold', 'Honey Rogers', 'Bubble Gims', 'Anthonio Bris', 'Lili Boom', 'Orel Turkey', 'Gotham Pearls', 'Super Angelina', 'Gege Volt', 'Lulita Pepita', 'Colorado Hills', 'Cameroon Gills', 'Boby Getto', 'Susan Lee', 'Bruce Bardon', 'Race Rare', 'Koki Tunes', 'Melody Letho', 'Kleb Lagaffe', 'Basyl Detective', 'Jet Flash', 'Pilou Danger', 'Terra Mary', 'Walls William', 'Marely Lynx', 'Octavio le Rhino', 'Judith Rich', 'Popo Lemon', 'Georget Smooth', 'Missy Lily', 'Dody Duck', 'Bull Lebrey', 'Vivian Nock', 'Elysa Fontana', 'Rose Duchelle', 'Olga Miles', 'Lolita Bourges', 'Sandra Bournes', 'Afro Manu'],
    'type-movies': ['Star', 'Drama', 'Fantastic', 'Original', 'Horror', 'Cartoons', 'Kiddos', 'Comet', 'Rocket', 'Babies', 'Dancing', 'Racing', 'Fighting', 'Martial Arts', 'Boxing', 'Ninja', 'Fencing', 'Soccer', 'Karate', 'Kung-Fu', 'Tai-Chi', 'Shaolin'],
    'civil-status': ['single','married','divorced','widowed'],
    fract: '',
    cond: '',
},
consts = {
    seconds_in_minute: 60,
    seconds_in_hour: 60 * 60,
    minutes_in_hour: 60,
    hours_in_day: 24,
    days_in_month_30: 30,
    days_in_month_31: 31,
    days_in_leap_year: 366,
    days_in_normal_year: 365,
    days_in_week: 7,
    weeks_in_year: 52,
    months_in_year: 12,

    twice: 2,
    dozen: 12,
},
signs = ['+', '/', '-', '*', '<', '>', '>>', '<<', 'fract', 'rsd', 'wtn', 'pv', 'ntw', 'wtn', 'itr', 'rti'], litterals = {
    plus: '+,plus,add',
    minus: '-,minus',
    div: '/,div',
    times: '*,x,times,X',
    lcm: '<,lcm,ppcm,',
    gcf: '>,gcf,pgcd,',
    max: '>>,greatest,max', // find max of numbers or fractions
    min: '<<,least,min', // find min of numbers or fractions
    fraction:'fract',  // make a fraction
    fad: 'fad',  // fraction as division
    rsd: 'rsd',  // reduce fractions to same denominator
    fon: 'fon',  // fraction of numbers
    add_sent: '+t',
    sub_sent: '-t',
    place_value: 'pv', // Place values are the location of the digits in any number
    wtn: 'wtd,wtn,w-t-n', // Word to number conversion
    ntw: 'ntw,n-t-w', //Number to word conversion
    itr: 'itr', // Int to roman
    rti: 'rti', // Roman to Int
    dvr: 'dvr', // Divisibility rules
    mod: '%,mod', // Modulo/rest of division
},
comparators = {
    //l'ordre des comparateur compte: des plus composés aux plus simples.
    eq: {val: '==', title: "equal to", lbl: 'eq'},
    lte: {val: '<=', title: "left or equal to", lbl: 'lte'},
    gte: {val: '>=', title: "great or equal to", lbl: 'gte'},
    df: {val: '!=', title: "left than", lbl: 'lt'},
    lt: {val: '<', title: "left than", lbl: 'lt'},
    gt: {val: '>', title: "great than", lbl: 'gt'},
},

operators = {
    signs: signs,
    litterals: litterals,
    checkOp_plus(op){
        return litterals.plus.split(',').includes(op);
    },
    checkOp_minus(op){
        return litterals.minus.split(',').includes(op);
    },
    checkOp_div(op){
        return litterals.div.split(',').includes(op);
    },
    checkOp_times(op){
        return litterals.times.split(',').includes(op);
    },
    checkOp_sign(op){
        return signs.includes(op) || Object.keys(litterals).map(k => litterals[k].split(',').includes(op)).reduce((a, b) => a || b, false);
        let keys = Object.keys(litterals).map(k => litterals[k].split(',').includes(op)).reduce((a, b) => a || b, false);
        return this.checkOp_plus(op)
            || this.checkOp_times(op)
            || this.checkOp_minus(op)
            || this.checkOp_div(op)
            || this.checkOp_lcm(op)
            || this.checkOp_gcf(op)
            || this.checkOp_max(op)
            || this.checkOp_min(op)
            || this.checkOp_unknow('rsd', op)
            || this.checkOp_unknow('fad', op)
            || this.checkOp_unknow('fon', op)
            || this.checkOp_fract(op)
            || this.checkOp_unknow('add_sent', op)
            || this.checkOp_unknow('place_value', op)
            || this.checkOp_unknow('sub_sent', op);
    },
    checkOp_lcm(op){
        return litterals.lcm.split(',').includes(op);
    },
    checkOp_gcf(op){
        return litterals.gcf.split(',').includes(op);
    },
    checkOp_max(op){
        return litterals.max.split(',').includes(op);
    },
    checkOp_min(op){
        return litterals.min.split(',').includes(op);
    },
    checkOp_fract(op){
        return litterals.fraction.split(',').includes(op);
    },
    checkOp_unknow(prop, op){
        // log('checkOp_unknow of prop:', prop, "with op:", op, "litterals:", litterals[prop], 'tab_litterals:', litterals[prop].split(','));
        return litterals[prop].split(',').includes(op);
    },
    checkOp_IntRes(op) {
        return this.checkOp_plus(op)
            || this.checkOp_minus(op)
            || this.checkOp_div(op)
            || this.checkOp_times(op)
            || this.checkOp_lcm(op)
            || this.checkOp_gcf(op)
            || this.checkOp_max(op)
            || this.checkOp_min(op)
    }
},

operations = {
    addition() {
        let args = loadArgNumbers(arguments), ld = args.map(el => el.D_P()).max().getLength(), res = args.reduce((a, b) => a + b, 0);
        return args.map(el => parseInt(el) == el).reduce((a, b) => a && b, true) ? res : res.toFixed(ld);
    },
    additionFract(op) {
        let fraOperation = loadArgs(arguments).flat().slice(1), args = fraOperation.map(el => new Fraction(el)),
        den_commun = ppcm(args.map(elt => elt.den)),
        resFraction, resNum, m = den_commun / fraOperation[1].den,
        extras = [], reduced = args.map(el => el.get_reduced(den_commun)),
        num_operation = "(" + fraOperation[0].num + " X " + m + ") ";

        extras.push({num: args.map(el=>{
            let m = den_commun/el.den;
            return m === 1 ? el.num : '(' + el.num + ' x ' + m + ')'
        }).join(' ' + op + ' '), den: den_commun});

        if(args.map(el => el.den != den_commun).reduce((a, b) => a || b, false)){
            extras.push({num: reduced.map(el => el.num).join(`${op}`), den: den_commun});
        }
        // extras.push();
        resNum = new Fraction({num: reduced.map(el => el.num).reduce((a, b) => operators.checkOp_plus(op) ? a + b : a - b), den: den_commun});
        resFraction = new Fraction(resNum, den_commun);

        resFraction.extras = extras;
        return resFraction;
    },
    additionSentence() {
        let args = loadArgNumbers(arguments);
        let addition = this.addition(args);
        return permutation(args).map(perm => perm.join(' + ') + ' = ' + addition);
    },
    subtractionSentence() {
        let args = loadArgNumbers(arguments), subtraction = this.soustract(args);
        // log('subtractionSentence with arguments:', args, 'subtraction:', subtraction, 'result:', args.join(' - ') + ' = ' + subtraction);
        return args.join(' - ') + ' = ' + subtraction;
    },
    soustract() {
        let args = loadArgNumbers(arguments), ld = args.map(el => el.D_P()).max().getLength();
        let res = args.reduce((a, b) => a - b);
        return args.map(el => parseInt(el) == el).reduce((a, b) => a && b, true) ? res : res.toFixed(ld);
    },
    multiplication() {
        let args = loadArgNumbers(arguments), ld = args.map(el => el.D_P().length).reduce((a, b) => a + b, 0),
        res = args.reduce((a, b) => a * b, 1);
        return args.map(el => parseInt(el) == el).reduce((a, b) => a && b, true) ? res : res.toFixed(ld);
    },
    division() {
        let args = loadArgNumbers(arguments), res = args.reduce((a, b) => a / b) ;
        if (args[0] % args[1] != 0) {/*
            let floating = args.map(el => el.D_P().length).max();*/
            res = Number(res.toFixed(5));
        }
        return res;
    },
    multiplicationFract(){
        let args = loadArgs(arguments).flat().map(el => new Fraction(el)), res, num, den,extras = [];
        res = new Fraction(args.map(el => el.num).reduce((a, b) => a * b), args.map(el => el.den).reduce((a, b) => a * b));

        extras.push(new Fraction({num:args.map(el => el.num).join(" x "), den:args.map(el => el.den).join(" x ") }));

        res.extras = extras;
        return res;
    },
    divFract(){
        let args = loadArgs(arguments).flat().map(el => new Fraction(el)).slice(0, 2), res, num, den,extras = [], fract1 = args[0], fract2 = args[1].inverse;
        extras.push(fract1 + ' x ' + fract2);
        let multi = this.multiplicationFract(fract1,fract2);
        res = new Fraction(multi);
        extras.push(...multi.extras);
        res.extras = extras;
        return res;
    },
    lcm(){
        let args = loadArgNumbers(arguments);
        return ppcm(args);
    },
    gcf(){
        let args = loadArgNumbers(arguments);
        return pgcd(args);
    },
    min(){
        let args = loadArgs(arguments).flat(), isFract = args.map(el => $functions.is_fraction(el)).reduce((a,b) => a || b, false), res;
            if(isFract){
                let arr = this.rsd_fractions(args), min_num = Math.min(...arr.map(el => el.num));
                res = arr.filter(el => el.num == min_num).pop();
            }else{
                res = Math.min(...args);
            }
        return res;
    },
    max(){
        let args = loadArgs(arguments).flat(), isFract = args.map(el => $functions.is_fraction(el)).reduce((a, b) => a || b, false), res;
            if(isFract){
                let arr = this.rsd_fractions(args), max_num = Math.max(...arr.map(el => el.num));
                res = arr.filter(el => el.num == max_num).pop();
            }else{
                res = Math.max(...args);
            }
        return res;
    },
    fract(){
        let args = loadArgNumbers(arguments);
        return new Fraction(args[0], args[1]);
    },
    rsd_fractions(){
        let args = loadArgs(arguments).flat().map(el => {
            let fract = new Fraction(el);
                return fract.simplificated == el ? fract : new Fraction(fract.simplificated);
            }), m = ppcm(...args.map(el => el.den));
        // log('args:', args, 'originals:', arguments);
        return args.map(el => el.get_reduced(m));
    },
    placeValue() {
        let args = loadArgNumbers(arguments);
        if (args.length < 2 || !args[0].toString().includes(args[1])) {
            return -1;
        }
        let number = args[0].toString(), digit = args[1].toString(), index = number.indexOf(digit), res = number.split('');
        return Math.pow(10, number.length - index - 1) * digit;
    },
    wordToNumber(str) {
        return wordsToNumbers(str || '');
    },
    numberToWord(nbre) {
        // log('Number to word the number:', nbre, 'answer is:', writtenNumber(nbre || ''));
        return writtenNumber(nbre);
    },
    intToRoman(nbre) {
        // log('int to roman on core fi=unction, int:', nbre, 'roman:', convertRoman.intToRoman((parseInt(nbre))));
        return convertRoman.intToRoman((parseInt(nbre)));
    },
    romanToInt(roman) { return convertRoman.romanToInt(roman); },
    unknow(op, arr){
        let fract = arr.map(el => $functions.is_fraction(el)).reduce((a, b) => a || b, false);
        if(operators.checkOp_plus(op)){
            return fract ? this.additionFract(op, arr) : this.addition(arr);
        }
        if(operators.checkOp_div(op)){
            let res = fract ? this.divFract(arr) : this.division(arr)
            return res;
        }
        if(operators.checkOp_minus(op)){
            return fract ? this.additionFract(op, arr) : this.soustract(arr);
        }
        if(operators.checkOp_times(op)){
            return fract ? this.multiplicationFract(arr) : this.multiplication(arr);
        }
        if(operators.checkOp_lcm(op)){
            return this.lcm(arr);
        }
        if(operators.checkOp_gcf(op)){
            return this.gcf(arr);
        }
        if(operators.checkOp_min(op)){
            return this.min(arr);
        }
        if(operators.checkOp_max(op)){
            return this.max(arr);
        }
        if(operators.checkOp_fract(op) || operators.checkOp_unknow('fad', op)){
            return this.fract(arr);
        }
        if(operators.checkOp_unknow('rsd', op)){
            return this.rsd_fractions(arr)
        }
        if(operators.checkOp_unknow('fon', op)){
            return this.multiplicationFract(arr).intVal
        }
        if(operators.checkOp_unknow('add_sent', op)) {
            return this.additionSentence(arr);
        }
        if(operators.checkOp_unknow('sub_sent', op)) {
            return this.subtractionSentence(arr);
        }
        if(operators.checkOp_unknow('place_value', op)) {
            return this.placeValue(arr);
        }
        if (operators.checkOp_unknow('wtn', op)) {
            return this.wordToNumber(arr.shift());
        }
        if (operators.checkOp_unknow('ntw', op)) {
            return this.numberToWord(arr.shift());
        }
        if (operators.checkOp_unknow('itr', op)) {
            // log('int to roman in unknow operation');
            return this.intToRoman(arr.shift());
        }
        if (operators.checkOp_unknow('rti', op)) {
            return this.romanToInt(arr.shift());
        }
        // divisibility rules
        if (operators.checkOp_unknow('dvr', op)) {
            arr = arr.filter(Number);
            let n = arr[0]; nbres = arr.slice(1);
            return nbres.length == 0 ? 'No' : (nbres.every((nbre, i) => nbre % n == 0) ? 'Yes' : 'No');
        }
        if (operators.checkOp_unknow('mod', op)) {
            arr = arr.filter(Number);
            if (arr.length > 2) return arr.pop();
            return arr[0] % arr[1];
        }
        else {
            log('operator"', op, '" is an unknowed operator');
        }
    },
},

params = {
    month:['', 'january', 'febuary', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
    day:['','monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
    month_30:['april','june','september','november'],
    month_31:['january', 'march', 'may', 'july', 'august', 'october', 'december'],
};

function loadArgs($arguments){
    return Array.from($arguments);
}
function loadArgNumbers($args){
    let args = loadArgs($args).flat(2), float = false;
    for(let i=0; i < args.length; i++){
        float = float || parseFloat(args[i]) != parseInt(args[i])
    }
    args = float ? args.filterFloat() : args.filterInt();
    return args;
}

function decompose(num) {
    if(num.isPrime()){
        return {p: 1, num: num};
    }
    let arr = [], n = num, p;
    for(let i = 2; i < ParseInt(Math.sqrt(num)); i++){
        if(i.isPrime()){
            p = 0;
            for(let j = 1; n % i == 0; j++){
                n = n / i;
                p++;
            }
            arr.push({p: p, num: i});
        }
    }
    return arr;
}
function permutation(xs) {
    let ret = [];

    for (let i = 0; i < xs.length; i = i + 1) {
        let rest = permutation(xs.slice(0, i).concat(xs.slice(i + 1)));

        if(!rest.length) {
            ret.push([xs[i]])
        } else {
            for(let j = 0; j < rest.length; j = j + 1) {
                ret.push([xs[i]].concat(rest[j]))
            }
        }
    }
    return ret;
}

const functions_vars = {
    in: { title: 'pick a value in a set of options. options are in a string and separated by "||"', value: 'in', nbre_params: Infinity, except: ['cond'] },
    bt: { title: 'for number: pick a value between 2 numbers start and end: start||end', value: 'bt', nbre_params: 2, only: ['float','int'] },
    gt: { title: 'pick a value greater than specified one', value: 'gt', nbre_params: 1, only: ['float','int'] },
    lt: { title: 'pick a value less than specified one', value: 'lt', nbre_params: 1, only: ['float','int'] },
    max: { title: 'get a value max of a set of options. options are in a string and separated by "||"', value: 'max', nbre_params: Infinity, only: ['float', 'int'] },
    min: { title: 'get a value min of a set of options. options are in a string and separated by "||"', value: 'min', nbre_params: Infinity, only: ['float', 'int'] },
    letter: { title: 'get letter word of a number', value: 'letter', nbre_params: 1, only: ['int'] },
    index: { title: 'get with a specified index on array of "type" values. Good for consecutive values(days, months, etc.)', value: 'index', nbre_params: 1, except: ['float','int','fract','cond'] },
    if: { title: "work as ternary operator",only: ['cond'], value: "if", nbre_params: 3, recursive: true },
    empty: { title: '', value: '', nbre_params: 0, only: [] },
};
const transform_answer_tab = {
    nospace: {title: "No considere space while evaluating answer", value: "no-space", only: ['text']},
    monospace: {title: "Considere only one space between words while evaluating answer", value: "mono-space", only: ['text']},
};

const operation_others_props = [
    {value: "estimated", title: "Operation d'estimation"},
    {value: 'isFloat', title: "Opération décimale"},
    {value: 'fract', title: "Operation fractionelle"},
],
joiners = [{value: "&&", title: "ET logique"}, {value: '@@', title: "OU logique"}, {value: "^", title: "ou esclusif"}];

exports.vars = variables;
exports.consts = consts;
exports.grades = grades;
exports.operators = operators;
exports.splitChars = "@@";
exports.escapeString = escapeString;
exports.operations = operations;
exports.params = params;
exports.functions_vars = functions_vars;
exports.transform_answer_tab = transform_answer_tab;
exports.operation_others_props = operation_others_props;
exports.joiners = joiners;
exports.comparators = comparators;
exports.apreciations = ['Good', 'Amazing', 'Success', 'Perfect', 'Excellent', 'Great']
// module.exports

